var React = require( 'react' );
var createReactClass = require('create-react-class');
var ContentMarkDown = require( '../../../education/components/layout/contentMarkDown.jsx' );

var TopicListItem = createReactClass({

    render: function(){
        return (
            <li className="accordion-item" data-accordion-item>
                <a className="accordion-title" href="#" // eslint-disable-line jsx-a11y/href-no-hash
                ><h4>{this.props.topic.title}</h4></a>
                <div className="accordion-content" data-tab-content>
                    <ContentMarkDown payload={this.props.topic.text} />
                </div>
            </li>
        );
    }
});

module.exports = TopicListItem;



// WEBPACK FOOTER //
// ./src/common/routes/faqs/components/layout/topicListItem.jsx